import { useEffect } from 'react'
import './Intro.css'
import Magnet from '../Magnet/Magnet'

function Intro() {

  useEffect(() => {
    const handleScroll = () => {
      const bg = document.querySelector('.uno .bg');
      const section = document.querySelector('.uno');

      if (bg && section) {
        const scrollValue = window.scrollY;
        const sectionOffset = section.offsetTop;
        const screenHeight = window.innerHeight;
        const sectionHeight = section.offsetHeight;

        const distance = (scrollValue + screenHeight / 2) - (sectionOffset + sectionHeight / 2);
        const yPos = distance * 0.12;

        bg.style.transform = `translateY(${yPos}px) scale(1.05)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='intro'>
      <div className='intro__bgGlow' />

      <div className='intro__grid'>
        <div className='intro__copy'>
          <span className='intro__eyebrow'>SOBRE NOSOTROS</span>
          <p className='intro__text'>
            En <b>Drontalia</b> llevamos la tecnología al cielo para ofrecer una nueva forma de entender el territorio.
            A través de vuelos profesionales con drones, capturamos información precisa y detallada que permite analizar,
            planificar y actuar con mayor seguridad.
          </p>
          <h2 className='intro__slogan'>Precisión aérea, datos que transforman decisiones</h2>

          <Magnet padding={30} disabled={false} magnetStrength={2} wrapperClassName='magneto' innerClassName='magnetoDos'>
            <button
              onClick={() => document.getElementById("contacto").scrollIntoView({ behavior: "smooth" })}
              className='intro__cta'
            >
              <span>CONTÁCTANOS</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </Magnet>
        </div>

        <div className='intro__media'>
          <div className='intro__mediaFrame'>
            <video src="/media/despegue.mp4" alt="intro" playsInline loop muted autoPlay preload="metadata" />
          </div>
          <div className='intro__mediaGlow' />
        </div>
      </div>

      <div className="separador uno">
        <div className="bg"></div>
        <div className="overlay"></div>
      </div>
    </div>
  )
}

export default Intro
